import "accordion-js/dist/accordion.min.css";
// @ts-ignore
import Accordion from "accordion-js";

export default () => {
  const faqSections = document.querySelectorAll('.faq');
  faqSections.forEach((faq) => new Accordion(faq));
}
